<template>
    <div class="d-flex flex-column vh-100">
      <NavigationBar></NavigationBar>
        <div class="d-flex flex-grow-1">
          <div class="card w-100">
            <b-tabs card class="h-100">
              <b-tab title="Compliance" active class="p-0">
                <DenounceMenu></DenounceMenu>
                <DenounceLink></DenounceLink>
                <DenounceList></DenounceList>
                <FooterView></FooterView>
              </b-tab>

              <b-tab title="Ley Karin" lazy class="p-0">
                <KarinMenu></KarinMenu>
                <KarinFilter></KarinFilter>
                <KarinList></KarinList>
                <FooterView></FooterView>
              </b-tab>
            </b-tabs>
          </div>
        </div>
    </div>
</template>

<script>
import NavigationBar from '@/components/shared/Navigation-bar.vue';
import DenounceMenu from '@/components/Denounce/Denounce-menu.vue';
import DenounceList from '@/components/Denounce/Denounce-list.vue';
import DenounceLink from '@/components/Denounce/Denounce-link.vue';
import FooterView from '@/components/shared/Footer/Footer-view.vue';
import KarinMenu from "@/components/KarinLaw/Karin-menu.vue";
import KarinList from "@/components/KarinLaw/Karin-list.vue";
import KarinFilter from "@/components/KarinLaw/Karin-filter.vue";

export default {
    name: 'DenounceViews',

    components:{
      KarinMenu,
      KarinList,
      KarinFilter,
      NavigationBar,
      DenounceMenu,
      DenounceList,
      DenounceLink,
      FooterView
    }
}
</script>
<style scoped>
.card {
  overflow-y: auto;
}
</style>